import $ from 'jquery';

export default (container = document) => {
  $('[data-shoppable]', container).each((i, trigger) => {
    const $trigger = $(trigger);
    $trigger.addClass('ShoppableImage__trigger');
    $trigger.parent('.RteFullCaption__image-wrapper').addClass('ShoppableImage__trigger-parent');

    const trigger_button = `
      <div class="ShoppableImage__trigger-button Button"  tabindex="0" role="button" data-shoppable-trigger>
        Shop Favorites
      </div>
    `;

    const trigger_button_shifted = `
    <div class="ShoppableImage__trigger-button ShoppableImage__trigger-button--shifted Button" tabindex="0" role="button"  data-shoppable-trigger>
      Shop Favorites
    </div>
  `;

    if ($trigger.is('img') && $trigger.parent().siblings('.RteFullCaption__description').length > 0) {
      $trigger.after(trigger_button_shifted);
    } else if ($trigger.is('img')) {
      $trigger.after(trigger_button);
    } else {
      $trigger.append(trigger_button);
    }
  });
};